<ng-container *ngIf="visitorInfoField.type !== visitorInfoFieldType.CUSTOM_FIELDS && !isHidden">
  <div class="visitor-info-item">
    <div class="info info-name" [ngSwitch]="visitorInfoField.type" [ngClass]="{ 'grey': visitorInfoField.value }" title="{{ visitorInfoField.translateKey ? ('bcVisitorInfo.' + visitorInfoField.translateKey | translate) : visitorInfoField.label }} {{ getValue() }}">
      <span>{{ visitorInfoField.translateKey ? ('bcVisitorInfo.' + visitorInfoField.translateKey | translate) : visitorInfoField.label }}</span>
      <ng-container *ngSwitchDefault>
        <span id="common-field" class="value" *ngIf="hasValue()">{{ getValue() }}</span>
      </ng-container>
      <ng-container *ngSwitchCase="visitorInfoFieldType.LINKABLE">
        <span class="value" *ngIf="visitorInfoField.value">
          <a id="linkable-field" [href]="getValue()" target="_blank">{{ getValue() }}</a>
        </span>
      </ng-container>
      <ng-container *ngSwitchCase="visitorInfoFieldType.EMAIL">
        <form ngNativeValidate *ngIf="editingEmail" (ngSubmit)="editEmail()">
          <input class="bc-input"
                 id="email-input-field"
                 [(ngModel)]="visitorInfoField.value"
                 [ngModelOptions]="{standalone: true}"
                 type="email"
                 [ngClass]="{ 'invalid': !visitorInfoField.value }"
          #emailInput />
        </form>
        <span class="value" *ngIf="visitorInfoField.value && !editingEmail">
          <a id="email-field" href="mailto:{{ getValue() }}">{{ getValue() }}</a>
        </span>
        <ng-container *ngIf="visitorInfoField.editable">
          <span id="not-available-email" class="value not-available" *ngIf="!visitorInfoField.value && !editingEmail">{{ 'bcVisitorInfo.notAvailable' | translate }}</span>
          <a id="email-edit" (click)="editEmail()" class="edit-icon"><i class="glyphicon glyphicon-pencil"></i></a>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="visitorInfoFieldType.PHONE">
        <form *ngIf="editingPhone" (ngSubmit)="editPhone()">
          <input class="bc-input"
                 id="phone-input-field"
                 [(ngModel)]="visitorInfoField.value"
                 (ngModelChange)="restrictPhone()"
                 [ngModelOptions]="{standalone: true}"
                 type="tel"
                 maxlength="30"
                 [ngClass]="{ 'invalid': !visitorInfoField.value }"
          #phoneNumberInput />
        </form>
        <span class="value" *ngIf="visitorInfoField.value && !editingPhone">
          <a id="phone-field" href="tel:{{ getValue() }}">{{ getValue() }}</a>
        </span>
        <ng-container *ngIf="visitorInfoField.editable">
          <span id="not-available-phone" class="value not-available" *ngIf="!visitorInfoField.value && !editingPhone">{{ 'bcVisitorInfo.notAvailable' | translate }}</span>
          <a id="phone-edit" (click)="editPhone()" class="edit-icon"><i class="glyphicon glyphicon-pencil"></i></a>
        </ng-container>
      </ng-container>
      <span data-automation-id="not-available" class="value not-available" *ngIf="!hasValue() && !visitorInfoField.editable">{{ 'bcVisitorInfo.notAvailable' | translate }}</span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="visitorInfoField.type === visitorInfoFieldType.CUSTOM_FIELDS">
  <div class="visitor-info-item" *ngFor="let customField of visitorInfoField.value">
    <div *ngIf="hasCustomFieldValue(customField.value)" class="info info-pre-chat-custom" [ngClass]="{ 'grey': !customField.value }" title="{{ customField.label }}: {{ customField.value }}">
      <span id="custom-field-label">{{ customField.label }}</span>
      <span id="custom-field-value" class="value visitor-info-pre-chat-custom-field">{{ customField.value }}</span>
    </div>
    <div *ngIf="!hasCustomFieldValue(customField.value) && !isNotAvailableDataHidden" class="info info-pre-chat-custom" [ngClass]="{ 'grey': !customField.value }" title="{{ customField.label }}: {{ customField.value }}">
      <span id="custom-field-label-not-available">{{ customField.label }}</span>
      <div class="not-available">{{ 'bcVisitorInfo.notAvailable' | translate }}</div>
    </div>
  </div>
</ng-container>
